import React, { Fragment, useState, useEffect, useRef, useImperativeHandle } from "react";
import { useReactToPrint } from "react-to-print";
import { Link, useLocation } from "react-router-dom";
import logo from '../jsx/components/Reports/food.jpeg';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from 'react-bootstrap';

const Invoice = React.forwardRef((props, ref) => {
  const location = useLocation();
  const componentRef = useRef();
  const currentDate = new Date();

  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);

  const userData = JSON.parse(localStorage.getItem('USER_data')) || {};
  const username = userData.name || "Unknown User";
  const [inviteModal, setInviteModal] = useState(false);

  // PDF generation functionality
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Invoice",
   });

  // Exposing showInviteModal method via Imperative Handle
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
      setOrderItems(props.data1);
      setOrder(props.data);
      setTotalAmount(calculateTotal(props.data1));
    },
  }));
  useEffect(() => {
    if(props.data)
   { setOrderItems(props.data1);
    setOrder(props.data);}
  }, [props.data ,setOrder]);
  // Calculate total amount from repair details
  const calculateTotal = (items) => {
    if (!items) return 0;
    return items.reduce((total, item) => {
      const serviceCost = parseFloat(item.ServiceCost || 0);
      const partCost = parseFloat(item.PartCost || 0);
      const partQuantity = parseFloat(item.PartQuantities || 0);
      console.log(serviceCost)
      console.log(partQuantity)

      console.log(partCost)

      return total + serviceCost + (partCost * partQuantity);
    }, 0);
  };
  const [company, setcompany] = useState([]);
  useEffect(() => {
    const companydata = localStorage.getItem('companies');
    if (companydata) {
      const parsedData = JSON.parse(companydata);
      const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
      setcompany(singleCompany); // Set state to a single object
    }
  }, []);
  // Update total when orderItems change
  useEffect(() => {
    if (props.data1) {
      setTotalAmount(calculateTotal(props.data1));
    }
  // const companydata = localStorage.getItem('companies');
 
    //setcompany(JSON.parse(companydata));
   // console.log('company',company)
   }, [props.data1]);
  console.log(props.data1)

  // Format the current date
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Notify for successful actions
  const notifyTopRight = () => {
    toast.success("✔️ تمت عملية الحفظ بنجاح", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
    });
  };

  // Convert number to Arabic words
  const numberToArabicWords = (number) => {
    const ones = ["", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة"];
    const tens = ["", "عشرة", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"];
    const hundreds = ["", "مائة", "مائتان", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"];

    if (number === 0) return "صفر";
    const parts = [];

    if (number >= 1000) {
      parts.push("ألف");
      number %= 1000;
    }

    if (number >= 100) {
      parts.push(hundreds[Math.floor(number / 100)]);
      number %= 100;
    }

    if (number >= 10 && number <= 19) {
      parts.push(ones[number % 10]);
      number = 0;
    } else if (number >= 10) {
      parts.push(tens[Math.floor(number / 10)]);
      number %= 10;
    }

    if (number >= 1) {
      parts.push(ones[number]);
    }

    return parts.reverse().join(" و ");
  };

  return (
    <Fragment>
      <ToastContainer />
      <Modal className="modal fade" id="exampleModal1" size="xl" show={inviteModal} onHide={() => setInviteModal(false)} centered>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card mt-3" style={{border:'0'}}>
                <div className="card-body" ref={componentRef} dir="rtl">
                  {/* Header */}
                 {/* <div className="row">
                    <div className="col-xl-12 text-center row">
                    <div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
     }}>  <div 
    style={{
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
                    <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                   <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter'}}>{company.Description}</h2>  </div>
                   <div className="d-flex">                    <i class="fa-solid fa-location-dot pt-1 ps-2" style={{color:'#8e2927'}}></i>
                    <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> {company.Address}</h2> <i class="fa-solid fa-phone-flip p-1 px-2" style={{color:'#8e2927'}}></i><h5 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}>{company.ContactNumber}</h5></div>
</div> 

 <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "150px", width: "200px",  marginTop:'-20px' }} />

                     </div>
                  </div> 
                  </div> 
  */}
     
 
 
                  {/* Order Details */}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>السيارة: {order.vehicle?.LicensePlate || ""}</td>
                          <td>الزبون: {order.customer?.FirstName || ""}</td>
                        </tr>
                        <tr>
                          <td>تاريخ الصيانة: {order.RepairDate || ""}</td>
                          <td>نوع الفاتورة: نهائية</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Repair Details */}
                    <table className="table table-bordered">
                       <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                        <tr>
                          <th>#</th>
                          <th>   اسم الخدمة /    اسم القطعة</th>
                          <th>الكمية</th>
                          <th>القطعة</th>
                          <th>  الاجمالي</th>
                        </tr>
                      </thead>
                      <tbody>
                        {props.data1.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.service?.ServiceName || item.parts?.PartName || "-"}</td>
                            <td>{item.PartQuantities || "-"}</td>
                            <td>{item.ServiceCost || item.PartCost || "-"}</td>
                            <td>{(item.PartQuantities * item.PartCost) || ( parseFloat(item.ServiceCost) ||0) || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Total Section */}
                  <div className="row">
                    <div className="col-lg-10"></div>
                    <div className="col-lg-2">
                      <table className="table">
                        <tbody>
                          <tr>
   <td><strong>الاجمالي</strong></td>
  <td>{TotalAmount.toFixed(2)}</td>
</tr>
<tr>
  <td><strong>العربون</strong></td>
  <td>{(parseFloat(order.Prepay) || 0).toFixed(2)}</td>
</tr>
<tr>
  <td><strong>الباقي</strong></td>
  <td>{(TotalAmount - (parseFloat(order.Prepay) || 0)).toFixed(2)}</td>
</tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="row">
                    <div className="col-xl-12 text-center">
                      <p>إعد بواسطة: {username}</p>
                      <p>بتاريخ: {formatDate(currentDate)}</p>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button className="btn btn-primary" onClick={generatePDF}>طباعه الفاتورة</button>
                  <Link to="#" className="btn btn-primary" onClick={()=>setInviteModal(false)}>انهاء</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
});

export default Invoice;
